import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { useNavigate } from "react-router-dom";

import aboutHero from "../assets/villa8.jpeg";

import villa1 from "../assets/villa15.jpg";
import villa2 from "../assets/villa16.jpeg";

function Villas() {

    const navigate = useNavigate();

    useEffect(() => {
        AOS.init({ duration: 900, once: true });
    }, []);

    return (
        <div className="w-full overflow-hidden">

            {/* ================= HERO SECTION ================= */}
            <section className="relative h-[60vh] w-full">
                <img
                    src={aboutHero}
                    alt=""
                    className="absolute inset-0 w-full h-full object-fixed"
                />
                <div className="absolute inset-0 bg-black/60" />

                <div className="relative z-10 flex h-full flex-col items-center justify-center text-center text-white px-4">
                    <h1 data-aos="fade-up" className="text-4xl border border-[#c97b3a] bg-black/40 backdrop-blur-sm p-6 sm:p-5 sm:text-3xl md:text-4xl font-bold mb-3">
                        Villas
                    </h1>
                </div>
            </section>

            {/* ================= ACCOMMODATION SECTION ================= */}
            <section className="py-16 bg-[#f6f4f1] px-4 md:px-10">

                {/* Section Heading */}
                <div className="max-w-6xl mx-auto text-center mb-20">
                    <h2 className="text-3xl md:text-4xl font-semibold mb-4">
                        Comfortable Villas for Families & Couples
                    </h2>
                    <p className="text-gray-600 max-w-2xl mx-auto">
                        Enjoy peaceful luxury surrounded by nature at Three Tree Villa by Habarana.
                        Whether you’re traveling with family or planning a romantic getaway,
                        we offer beautifully designed villas to suit your stay.
                    </p>
                </div>

                {/* ===== FAMILY VILLA (4 PEOPLE) ===== */}
                <div className="relative max-w-6xl mx-auto mb-28">
                    <div className="grid md:grid-cols-2 items-center">

                        {/* LEFT TEXT */}
                        <div className="bg-[#e9e2d9] p-12 md:p-10 z-10">
                            <h3 className="text-2xl md:text-3xl font-medium mb-6">
                                Family Villa (Up to 4 Guests)
                            </h3>

                            <p className="text-gray-700 mb-8 leading-relaxed">
                                Perfect for families or small groups, our spacious Family Villa
                                offers comfort, privacy, and a relaxing atmosphere surrounded by nature.
                                Enjoy quality time together in a peaceful tropical setting.
                            </p>

                            <ul className="space-y-4 text-gray-700">
                                <li>2 Single Beds</li>
                                <li>Private Bathroom</li>
                                <li>Living Area</li>
                                <li>Garden View</li>
                                <li>Suitable for 4 Guests</li>
                            </ul>

                            <button
                                onClick={() => navigate("/villas/family-villa")}
                                className="mt-10 border-b border-black pb-1 tracking-wider text-sm hover:text-[#c97b3a] transition">
                                MORE DETAILS —
                            </button>
                        </div>

                        {/* RIGHT IMAGE */}
                        <div className="relative md:-ml-16 mt-10 md:mt-0">
                            <img
                                src={villa1}
                                alt="Family Villa"
                                className="w-full h-[450px] object-cover shadow-xl"
                            />
                        </div>

                    </div>
                </div>

                {/* ===== COUPLE VILLA ===== */}
                <div className="relative max-w-6xl mx-auto -mt-8">
                    <div className="grid md:grid-cols-2 items-center">

                        {/* IMAGE LEFT */}
                        <div className="relative md:-mr-16 order-2 md:order-1 mt-10 md:mt-0">
                            <img
                                src={villa2}
                                alt="Single Room Villa"
                                className="w-full h-[450px] object-cover shadow-xl"
                            />
                        </div>

                        {/* TEXT RIGHT */}
                        <div className="bg-[#e9e2d9] p-12 md:p-10 order-1 z-10">
                            <h3 className="text-2xl md:text-3xl font-medium mb-6">
                                Single Room Villa (For Couples)
                            </h3>

                            <p className="text-gray-700 mb-8 leading-relaxed">
                                Designed for romantic escapes, our Single Room Villa offers
                                privacy, elegance, and peaceful surroundings — ideal for couples
                                looking to relax and reconnect in nature.
                            </p>

                            <ul className="space-y-4 text-gray-700">
                                <li>One Spacious Bedroom</li>
                                <li>Private Bathroom</li>
                                <li>Terrace / Garden View</li>
                                <li>Ideal for 2 Guests</li>
                            </ul>

                            <button
                                onClick={() => navigate("/villas/single-room-villa")}
                                className="mt-10 border-b border-black pb-1 tracking-wider text-sm hover:text-[#c97b3a] transition">
                                MORE DETAILS —
                            </button>
                        </div>

                    </div>
                </div>

            </section>

            {/* ================= WHATSAPP FLOAT BUTTON ================= */}
            <a
                href="https://wa.me/94764806045?text=I%20saw%20your%20website.%20Can%20you%20give%20me%20information%20regarding%20your%20villa."
                target="_blank"
                rel="noopener noreferrer"
                className="fixed bottom-5 right-5 z-50"
            >
                <img
                    src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/6b/WhatsApp.svg/512px-WhatsApp.svg.png"
                    alt="WhatsApp"
                    className="h-12 w-12 sm:h-14 sm:w-14 rounded-full shadow-lg transition hover:scale-110"
                />
            </a>

        </div>
    );
}

export default Villas;